__turbopack_context__.v({
  "blog": "RecentBlogs-module-scss-module___aEa7W__blog",
  "blogsList": "RecentBlogs-module-scss-module___aEa7W__blogsList",
  "heading": "RecentBlogs-module-scss-module___aEa7W__heading",
});
